import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import ApprovedExpertListTable from '../../components/table/approvedExpertListTable/ApprovedExpertListTable'

export default function ApprovedExpert({ schema }) {
  const [formSchema, setFormSchema] = useState(schema)

  return (
    <>
      <Panel shaded header={formSchema.header} bordered collapsible defaultExpanded>
        <ApprovedExpertListTable
          data={formSchema.itemsList}
          hideIsSentProposalFilterDocument={true}
          hideSentDate={true}
          hideUploadDocumentColumn={true}
          hideUploadDocumentCommand={true}
          hideInviteLetter={true}
          hideRound={true}
        />
      </Panel>
    </>
  )
}

// const expertData = [
//   {
//     id: '63-0001',
//     avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
//     firstName: 'รศ.ดร. กนก รัตนะกนกชัย',
//     colorstatus: { code: 1, labal: 'เห็นชอบ ' },
//     isApproved: true,
//     approvedReviewerDesc: 'เห็นชอบ',
//     status: 'ด้านวิชาการ',
//     date: 'เวอร์ชั่น 1.01 19 พ.ย. 2563 07:57 น.',
//     stars: 820,
//     dateWait: '12 พ.ย. 2563',
//     dateSubmit: ' 15 พ.ย. 2563',
//     Round: '1',
//     year: 2563,
//   },
//   {
//     id: '63-0002',
//     avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
//     firstName: 'ดร. กนกกาญจน์ พรหมน้อย',
//     colorstatus: { code: 2, labal: 'เห็นชอบ ' },
//     isApproved: true,
//     approvedReviewerDesc: 'เห็นชอบ',
//     status: 'ด้านพิธีการ',
//     date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
//     stars: 1200,
//     dateWait: '12 พ.ย. 2563',
//     dateSubmit: ' 15 พ.ย. 2563 ',
//     Round: '1',
//     year: 2563,
//   },
//   {
//     id: '63-0003',
//     avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
//     firstName: 'ผศ.พญ. กนกพร ภิญโญพรพาณิชย์',
//     colorstatus: { code: 3, labal: 'เห็นชอบ ' },
//     isApproved: true,
//     approvedReviewerDesc: 'เห็นชอบ',
//     status: 'ด้านการจัดการ/กระบวนการ ',
//     date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
//     stars: 610,
//     dateWait: '12 พ.ย. 2563',
//     dateSubmit: ' 15 พ.ย. 2563',
//     Round: '1',
//     year: 2563,
//   },
//   {
//     id: '63-0004',
//     avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
//     firstName: 'รองศาตราจารย์ ดร. กนกพร สังขรักษ์',
//     colorstatus: { code: 4, labal: 'รอพิจารณา ' },
//     approvedReviewerDesc: 'รอพิจารณา',
//     isApproved: false,
//     status: 'ด้านสื่อสาร',
//     date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
//     stars: 5322,
//     dateWait: '17 พ.ย. 2563',
//     dateSubmit: '',
//     Round: '2',
//     year: 2563,
//   },
//   {
//     id: '63-0005',
//     avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
//     firstName: 'ผศ.ดร. กนกพร สุคำวัง',
//     colorstatus: { code: 5, labal: 'รอพิจารณา ' },
//     isApproved: false,
//     approvedReviewerDesc: 'รอพิจารณา',
//     status: 'ด้านสันทนาการ',
//     date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
//     stars: 852,
//     dateWait: '18 พ.ย. 2563',
//     dateSubmit: ' ',
//     Round: '2',
//     year: 2563,
//   },
//   {
//     id: '63-0006',
//     avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
//     firstName: 'อ.ดร. กนกวรรณ ปัญจะมา',
//     colorstatus: { code: 6, labal: 'รอพิจารณา ' },
//     isApproved: false,
//     approvedReviewerDesc: 'รอพิจารณา',
//     status: 'ด้านวิทยาการ',
//     date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
//     stars: 3209,
//     dateWait: '22 พ.ย. 2563',
//     dateSubmit: '',
//     Round: '2',
//     year: 2563,
//   },
// ]
